import React from 'react';
import styled, { css } from 'styled-components';
import themeResponsiveProperty from "./responsive/themeResponsiveProperty";

function Checkbox({ onWrapperClick, ...props }) {
  return (
    <Checkbox.Wrapper onClick={onWrapperClick}>
      <input type="checkbox" {...props} />
      <Checkbox.Check />
    </Checkbox.Wrapper>
  )
}

export default Checkbox;

Checkbox.Check = styled.span`
  display: inline-flex;
  justify-content: center;
  align-content: center;
  width: ${themeResponsiveProperty('1rem', '1.25rem')};
  height: ${themeResponsiveProperty('1rem', '1.25rem')};
  border: 1px solid #000;
  background-color: transparent;
  transition: background-color 250ms ease;
`;

Checkbox.Wrapper = styled.label`
  display: inline-flex;

  input {
    display: none;
  }

  input + ${Checkbox.Check}:before {
    content: "";
    display: inline-block;

    ${props => props.theme.isMobile && css`
      width: .325rem;
      height: .625rem;
      margin-top: 0;
      border-bottom: .125rem solid #fff;
      border-right: .125rem solid #fff;
    `};

    ${props => props.theme.isTablet && css`
      width: .325rem;
      height: .625rem;
      margin-top: .125rem;
      border-bottom: 2px solid #020202;
      border-right: 2px solid #020202;
    `};

    transform: rotate(38deg) scale(0);
    transition: all ease-in-out 100ms;
  }

  input:checked + ${Checkbox.Check} {
      background-color: ${themeResponsiveProperty('#000', null)};
  }

  input:checked + ${Checkbox.Check}:before {
    transform: rotate(38deg) scale(1);
  }
`;
